import customerAPI from '@/services/API/customer'
import moment from 'moment';
import { Message } from 'element-ui';

function buildSearchAndFiltersParams(state){
  var params = {};
  params.orderBy = state.orderBy.orderName;
  params.direction = state.orderBy.direction;
  params['primary-only']=true
  params.active = state.filters.active;
  params.types = [];

  if(state.filters.withoutReps){
    params.withoutReps=true;
  }

  if(state.filters.withoutTerritories){
    params.withoutTerritories=true;
  }

  params.territoryId=[];
  _.forEach(state.filters.checkedTerritories, t=>{
   params.territoryId.push(t);
  })

  params.portausCompany = [];
  _.forEach(state.filters.checkedPortausCompanies, p=>{
    params.portausCompany.push(p);
   })



  params.repId=[];
  _.forEach(state.filters.checkedReps, r=>{
   params.repId.push(r);
  })
  params.customerClassId=[];
   _.forEach(state.filters.checkedCustomerClasses, c=>{
    params.customerClassId.push(c);
   })
   params.tag = [];
   _.forEach(state.filters.checkedTags, t=>{
    params.tag.push(t);
   })
   params.type=[];
   _.forEach(state.filters.checkedCustomerTypes, ct=>{
    params.type.push(ct);
   })
   params.searchTerms = _.trim(state.search);

   params.limit = state.per_page;
   params.page = state.page;

   if(params.page==0)params.page=1;
   return params;
}

// const fetchNextCustomersPage = function({commit, dispatch, state}){

//   commit('SET_PAGE',state.page+1);
//   // console.log("fetchNextCustomersPage : ", state.page);
//   let params = buildSearchAndFiltersParams(state);
//   commit('SET_LOADING', true);
//   return customerAPI.fetchCustomers(params)
//     .then(customers=>{
//       if(customers.count){
//         commit('UPDATE_CUSTOMERS', customers.customers);
//         commit('SET_COUNT', customers.count );
//         commit('SET_PAGES', customers.pages );

//       }
//       commit('SET_LOADING', false);
//     })
// }

const fetchNextPage = function({commit, state, dispatch}) {
  if (state.page < state.pages) {
    commit('SET_PAGE', state.page + 1);
    commit('INVALIDATE_LIST');
    dispatch('fetchCustomers');
  }
}

const fetchPreviousPage = function({commit, state, dispatch}) {
  if (state.page > 1) {
    commit('SET_PAGE', state.page - 1);
    commit('INVALIDATE_LIST');
    dispatch('fetchCustomers');
  }
}

const fetchCustomers = function({commit, state}){

  let params = buildSearchAndFiltersParams(state);

  if(state.outDated || _.isEmpty(state.list)){
    commit('SET_LOADING', true);
    return customerAPI.fetchCustomersV2(params)
      .then(customers=>{
        if(customers.count!=null){
          commit('SET_CUSTOMERS', customers.list);
          commit('SET_COUNT', customers.count );
          commit('SET_PAGES', customers.pages );
        }else{
          commit('SET_CUSTOMERS', customers);
        }
        commit('SET_LOADING', false);
      })
  }
}

const changeMode = function({commit}, mode){
  commit('SET_MODE',mode);
}

const invalidateList = function({commit, dispatch}){
  commit('INVALIDATE_LIST');
  commit('SET_PAGE',1);
  dispatch('fetchCustomers');
}

let searchTimeOut = null;
const setSearch = function({commit,dispatch},search){
  commit('SET_SEARCH',search);
  commit('SET_LOADING', true);
  clearTimeout(searchTimeOut)
  searchTimeOut = setTimeout(() => {
    dispatch('invalidateList');
    dispatch('fetchCustomers');
  }, 300)
}

const setCheckedCustomerTypes = function({commit, dispatch},checkedCustomerTypes){
  commit('SET_CHECKED_CUSTOMER_TYPES', checkedCustomerTypes);
  dispatch('invalidateList');
}

const setCheckedCustomerClasses = function({commit, dispatch}, checkedCustomerClasses){
  commit('SET_CHECKED_CUSTOMER_CLASSES', checkedCustomerClasses);
  dispatch('invalidateList');
}

const resetFilters = function({commit, dispatch}){
  commit('RESET_FILTERS');
  dispatch('invalidateList');
}

const resetAllFilters = function({dispatch}){
  dispatch('setSearch','');
  dispatch('resetFilters')
}

const setActiveCustomerFilter = function({commit, dispatch}, activeCustomerFilter){
  commit('SET_ACTIVE_CUSTOMER_FILTER', activeCustomerFilter);
  dispatch('invalidateList');
}

const setCheckedCustomerTags = function({commit, dispatch}, checkedCustomerTags){
  commit('SET_CHECKED_CUSTOMER_TAGS', checkedCustomerTags);
  dispatch('invalidateList');
}

const setCheckedReps = function({commit, dispatch}, checkedReps){
  commit('SET_CHECKED_REPS', checkedReps);
  dispatch('invalidateList');
}

const setCheckedTerritories = function({commit, dispatch}, checkedTerritories){
  commit('SET_CHECKED_TERRITORIES', checkedTerritories);
  dispatch('invalidateList');
}

const setCheckedPortausCompanies = function({commit, dispatch}, checkedPortausCompanies){
  commit('SET_CHECKED_PORTAUS_COMPANIES', checkedPortausCompanies);
  dispatch('invalidateList');
}

const setFilterWithoutReps = function({commit, dispatch}, withoutReps){
  commit('SET_WITHOUT_REPS_FILTER', withoutReps);
  dispatch('invalidateList');
}

const setFilterWithoutTerritories = function({commit, dispatch}, withoutTerritories){
  commit('SET_WITHOUT_TERRITORIES_FILTER', withoutTerritories);
  dispatch('invalidateList');
}

const setOrderBy = function ({commit,dispatch}, orderBy){
  commit('SET_ORDER_BY', orderBy);
  dispatch('invalidateList');
}
const setSortIcon = function ({commit,dispatch}, sortIcon){
  commit('SET_SORT_ICON', sortIcon);
  commit('invalidateList');
}

const getQueryParams = function({state}) {
  return buildSearchAndFiltersParams(state);
}


export default {
  // fetchNextCustomersPage,
  getQueryParams,
  changeMode,
  invalidateList,
  fetchCustomers,
  setSearch,
  setCheckedCustomerTypes,
  setCheckedCustomerClasses,
  resetFilters,
  setActiveCustomerFilter,
  resetAllFilters,
  setCheckedCustomerTags,
  setCheckedReps,
  setCheckedTerritories,
  setFilterWithoutReps,
  setFilterWithoutTerritories,
  setOrderBy,
  setSortIcon,
  setCheckedPortausCompanies,
  fetchNextPage,
  fetchPreviousPage,
};
